import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";

export default function RentDressDialog({ open, onClose, onSelect, dressList, dressSelectionService, additionalServices }) {
  const [search, setSearch] = useState("");
  const [selectedDress, setSelectedDress] = useState(null);
  const [dress, setDress] = useState(null);
  const [filteredDresses, setFilteredDresses] = useState([]);

  useEffect(() => {
    if (dressList) {
      setFilteredDresses(dressList.filter((dress) =>
        dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
        (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
      ));
    }
  }, [search, dressList]);


  const handleSelect = (dress) => {
    setSelectedDress(dress.dressID);
    setDress(dress);
  };

  const handleConfirm = () => {
    onSelect(dress);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Escoge el vestido a alquilar</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Selecciona el vestido que deseas rentar para este servicio.
        </DialogContentText>
        <TextField
          fullWidth
          margin="normal"
          label="Buscar vestido"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Grid container spacing={2}>
          {filteredDresses.map((dress) => (
            (dress.dressName !== 'No aplica') &&
            <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
              <Card
                onClick={() => handleSelect(dress)}
                sx={{
                  cursor: "pointer",
                  border:
                    selectedDress === dress.dressID
                      ? "2px solid #f759ab"
                      : "1px solid #e0e0e0",
                  boxShadow:
                    selectedDress === dress.dressID ? "0 4px 10px rgba(0,0,0,0.2)" : "none",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 15px rgba(0,0,0,0.3)",
                  },
                }}
              >
                <CardContent sx={{ display: "flex", flexDirection: "column", height: 100 }}>
                  <Typography variant="h6">
                    {dress.dressName}
                  </Typography>
                  <div style={{ display: 'flex', flexDirection: "column", fontSize: '0.9rem', marginTop: '0.7rem' }}>
                    <Typography variant="h7">
                      Código: {dress.code}
                    </Typography>
                    <Typography variant="h7">
                      Tipo: {dress.dressSize === 'long' ? 'Largo' : 'Corto'}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedDress}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
